import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const SecurityStatusCard = styled('div')<{ theme?: TTheme }>`
    padding: 20px;
    margin-bottom: 24px;
    background-color: ${({ theme }) =>
        theme.colors.semantic.backgroundSecondary};
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
`

export const TitleRow = styled('div')`
    display: flex;
    align-items: center;
    gap: 20px;
    width: 100%;
`
